import { render, staticRenderFns } from "./LegDetails.vue?vue&type=template&id=5c1fe6ba&"
import script from "./LegDetails.vue?vue&type=script&lang=js&"
export * from "./LegDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports